{
  "meta-main-title": "🧳 Buy Travel Insurance Policy in 2 Mins | QIC",
  "meta-main-desription": "Going on a vacation or business trip? Protect yourself with QIC insurance for travels and holidays in 4 steps: →🟩Enter your details →🟩Choose a cover →🟩Pay online →✅Done!",
  "quote_discount_online": "Discount",
  "not_found_message_line1": "Looks like the page you are looking is not",
  "not_found_message_line2": "available",
  "select_country_error": "Select a country",
  "from": "From",
  "inbound_from_header": "Where are you from?",
  "inbound_calendar_header": "Travel dates",
  "inbound_calendar_departure": "Departure",
  "inbound_traveling_persons_header": "Number of travelers",
  "inbound_travel_insurance_header": "Inbound Travel Insurance",
  "inbound_calendar_return": "Return",
  "inbound_nationality_header": "Select Your Nationality",
  "inbound_nationality_nationality": "Nationality",
  "inbound_id_header": "Enter Your Passport Number",
  "inbound_id_number": "Passport number",
  "inbound_dob_date": "Date of birth",
  "inbound_travelers_check_header": "Insured travelers",
  "inbound_travelers_check_passport": "Passport number",
  "inbound_travelers_select_nationality": "Nationality",
  "inbound_travelers_select_relationship": "Relationship",
  "inbound_travelers_edit_save_button": "Save",
  "inbound_travelers_delete_header": "Delete traveler's information?",
  "inbound_travelers_delete_cancel_button": "Cancel",
  "inbound_travelers_delete_accept_button": "Yes, delete",
  "inbound_travelers_add_relationship": "Relationship",
  "inbound_travelers_add_first_name": "First name",
  "inbound_travelers_add_last_name": "Family name",
  "inbound_travelers_add_qatar_id": "QID Number",
  "inbound_travelers_add_dob": "Date of birth",
  "inbound_travelers_add_nationality": "Nationality",
  "inbound_travelers_add_passport": "Passport number",
  "inbound_travelers_add_email": "Email",
  "inbound_travelers_add_mobile_number": "Mobile number",
  "inbound_quote_inclusive_covers": "Inclusive covers",
  "outbound_destinations_disc_us": "Select <b>Annual Multitrip<b> if you're planning to travel for more than 60 days",
  "outbound_destinations_disc_world": "Select <b>Annual Multitrip</b> if you're planning to travel to the US or Canada for more than 60 days",
  "outbound_destinations_disc_default": "Select <b>Annual Multitrip</b> if you're planning to travel for more than 90 days",
  "outbound_destinations_header": "Where are you going?",
  "outbound_destinations_label": "Country of destination",
  "outbound_destinations_subtitle": "You can add several countries",
  "outbound_travel_type_header": "Travel dates",
  "outbound_travel_type_header_multi": "Policy start date",
  "outbound_travel_type_multi": "Multi-trip",
  "outbound_travel_type_single": "Single trip",
  "outbound_travel_type_multi_desc": "Within a year",
  "outbound_travel_type_single_desc": "Up to 90 days",
  "outbound_calendar_header": "Travel dates",
  "outbound_calendar_single_departure": "Departure",
  "outbound_calendar_single_return": "Return",
  "outbound_calendar_annual_date": "Policy start date",
  "outbound_nationality_header": "Nationality",
  "outbound_nationality_nationality": "Nationality",
  "outbound_dob_date": "Date of birth",
  "outbound_sport_cover_winter_name": "Winter sports",
  "outbound_sport_cover_winter_cover_separately": "Select covers for every traveler",
  "outbound_sport_cover_winter_description": "Medical coverage if you get injured while skiing or snowboarding",
  "outbound_sport_cover_winter_description_new": "Medical coverage if you get injured while skiing or snowboarding. Insurance limit included in USD 1,000,000 emergency medical care coverage",
  "outbound_travelers_check_header": "Insured travelers",
  "outbound_travelers_check_add_button": "Add Another Person",
  "outbound_covid_cover_name": "COVID-19 Cover",
  "outbound_covid_cover_description": "Covers medical expenses, quarantine, and trip cancellation if you become ill with COVID-19",
  "outbound_covid_cover_description_new": "Covers medical expenses, quarantine, and trip cancellation if you become ill with COVID-19. Coverage up to USD 5,000",
  "outbound_covid_cover_all": "Covers all travelers",
  "outbound_additional_header": "Additional covers",
  "outbound_plans_header": "Select plan",
  "outbound_plans_destination": "Destination",
  "outbound_plans_world_name": "All World",
  "outbound_plans_world_description": "Full cover without excluded countries",
  "outbound_plans_europe_name": "Fly Europe",
  "outbound_plans_europe_description": "Basic insurance to avail a visa for Schengen countries",
  "outbound_plans_nna_name": "Worldwide, excluding USA and Canada",
  "outbound_plans_regional_name": "Regional",
  "outbound_plans_regional_description": "Includes GCC, Arab countries, India, Pakistan, Sri Lanka, Bangladesh, Korea, Philippines, Indonesia, Nepal, and Bhutan",
  "outbound_plans_ramadan_name": "Special Worldwide",
  "outbound_plans_ramadan_description": "Full cover without excluded countries",
  "outbound_plans_footertext": "The final price may change due to the number of insured people",
  "outbound_plan_recommended": "We recommend",
  "outbound_plan_select_button": "Select plan for {planPrice}",
  "outbound_quote_regional_name": "Regional",
  "qic_quote_destination": "Destination",
  "travellers_add_first": "Add first person",
  "travellers_add_person": "New traveler",
  "travellers_update_info": "Update the information",
  "travellers_insured": "Insured travelers",
  "travellers_passport": "Passport number",
  "travellers_disclaimer": "Make sure to provide a correct email address (Your insurance policy will be sent to the address you enter)",
  "home_header1": "Travel Insurance",
  "home_header_desc": "Trusted by over 200,000 customers in Qatar",
  "home_feedback_header1": "Trusted by over 200,000",
  "home_feedback_header2": "travelers in Qatar",
  "home_form_enter_departure": "Select Your Destination",
  "home_form_check_your_price": "Check Your Price",
  "home_includes_medical_header": "Medical Expenses",
  "home_includes_medical_desc": "Treatments and hospitalization if you get ill while traveling",
  "home_includes_covid_header": "Covid-19 Cover",
  "home_includes_covid_desc1": "Medical, hospitalization,",
  "home_includes_covid_desc2": "quarantine and trip",
  "home_includes_covid_desc3": "cancelation fees in case",
  "home_includes_covid_desc4": "of a COVID-19 infection",
  "home_includes_personal_header": "Personal Accidents",
  "home_includes_personal_desc1": "Accidents during your trip,",
  "home_includes_personal_desc2": "including injuries, disability,",
  "home_includes_personal_desc3": "and death",
  "home_includes_belonging_header": "Loss of Belongings",
  "home_includes_belonging_desc1": "Covers loss of your personal",
  "home_includes_belonging_desc2": "items during your trip",
  "home_includes_baggage_header": "Loss of Baggage",
  "home_includes_baggage_desc": "Compensation for lost luggage in airports or transit areas",
  "home_includes_tpd_header": "Third-Party Damage",
  "home_includes_tpd_desc": "Covers your liability for damages you may cause to others",
  "home_includes_winter_header": "Winter Sports Extension",
  "home_includes_winter_desc": "Medical coverage in the event of an accident or injury while skiing",
  "home_includes_trip_header": "Trip Cancelation",
  "home_includes_trip_desc1": "Covers non-refundable",
  "home_includes_trip_desc2": "expenses in case your trip",
  "home_includes_trip_desc3": "got canceled",
  "home_includes_passport_header": "Loss of Passport",
  "home_includes_passport_desc1": "Reimbursement for getting",
  "home_includes_passport_desc2": "a replacement travel document",
  "home_includes_legal_header": "Legal Expenses",
  "home_includes_legal_desc1": "Legal fees you might need",
  "home_includes_legal_desc2": "to pay while being abroad",
  "home_includes_terrorism_header": "Terrorism Attacks",
  "home_includes_terrorism_desc1": "Damages and injuries due",
  "home_includes_terrorism_desc2": "to terrorism acts abroad",
  "home_includes_header": "Travel Insurance Includes",
  "home_faq_item1_header": "Do I need to scan and submit any paperwork after getting my travel insurance quote online?",
  "home_faq_item1_content": "No. QIC is a digital insurance company, and the entire travel insurance buying process on our website is fully digital, instant and paperless.",
  "home_faq_item2_header": "For how long can my travel insurance policy be valid?",
  "home_faq_item2_content": "The period of cover for a travel insurance ranges from one week (1 week) to three months (3 months). The annual multi trip cover (including annual multi trip domestic travel) is valid through 12 months inclusive of a maximum of 90 days stay per each trip.",
  "home_faq_item3_header": "Can people over 70 get a travel insurance policy?",
  "home_faq_item3_content": "Yes. Senior people, pensioners, and elderly over the age 70 can get covered by a QIC travel insurance policy if they can provide a medical certificate stating that they are in good health and condition prior to the start of their journey. You will need to contact our manager to settle all the details.",
  "home_faq_item4_header": "Can I get travel insurance to all countries in the world?",
  "home_faq_item4_content": "Your travel insurance policy can cover your travels worldwide, excluding travels to North Korea, Iran and Venezuela. You can see the list of countries covered by QIC travel insurance here",
  "home_faq_item5_header": "Is QIC’s travel insurance adequate for Schengen visa insurance requirements?",
  "home_faq_item5_content": "Yes. QIC’s travel insurance policy offers medical insurance cover ranging from USD 50,000 to USD 1,000,000, which makes it fully adequate for the visa requirements of Schengen member states.",
  "home_faq_item6_header": "Can my travel insurance provide coverage for a one-way single trip?",
  "home_faq_item6_content": "Unfortunately no. QIC's travel insurance provides cover for return trip arrangements only.",
  "home_faq_item7_header": "Does QIC offer travel insurance to people travelling to Qatar as well?",
  "home_faq_item7_content": "Yes. QIC offers travel insurance to both travelers from Qatar (outbound travelers), and visitors coming to Qatar (inbound travelers).",
  "home_faq_item8_header": "Does QIC offer travel insurance for corporate and business trips?",
  "home_faq_item8_content": "Yes. QIC offers travel policy for business, corporate, tourism, volunteers,  family visit visa holders, training trips for students from one week to three months. The annual multiple cover is valid through one year inclusive of a maximum of 90 days stay per each trip..",
  "home_faq_item9_header": "Is there an estimated price list for travel insurance premiums?",
  "home_faq_item9_content": "No. The cost of your insurance is calculated individually based on a variety of factors, including your destination, the duration of your stay, your age and the covers you need. You can opt for a cheaper coverage or buy a fully comprehensive coverage with extra add-ons.",
  "home_faq_item10_header": "Does QIC offer any discounts or promotions on travel insurance policies for kids and families with babies?",
  "home_faq_item10_content": "Yes. QIC offers toddlers and children under the age of 18 a discount of 50% on the standard travel insurance premium.",
  "home_faq_item11_header": "Will my travel insurance cover my personal electronic equipment?",
  "home_faq_item11_content": "Yes.If you need gadget insurance abroad, you would like to know that QIC travel insurance covers electronic equipment, including laptops, cameras and other digital gadgets.",
  "home_faq_item12_header": "Does my travel insurance cover pre-existing conditions?",
  "home_faq_item12_content": "All pre-existing medical conditions are excluded from the scope of your travel insurance policy, including existing medical conditions and chronic diseases, such as diabetics, HIV, cancer, high cholesterol, mental health disorders, pregnancy, anxiety and depression, etc.. Make sure that your health insurance covers these cases..",
  "home_faq_item13_header": "Does my travel insurance cover me for extreme sports while aboard?",
  "home_faq_item13_content": "If you are a high risk voyager, you should know that  involvement in any adventurous sport (such as scuba diving, water sports, including jet skiing, trekking, motorcycle racing, sailing, redpoint climbing, etc.) is typically not covered within your travel insurance basic policy. However, your policy can be extended for an additional premium to include Winter Sports Extension that covers recreational on-piste skiing and snowboarding.",
  "home_faq_item14_header": "Can my travel insurance cover my pet cats and dogs travelling with me?",
  "home_faq_item14_content": "Domestic animals in general, including cats and dogs, are not covered in your basic travel insurance policy.",
  "home_faq_item15_header": "Does my travel insurance cover cars, vehicles and motorcycles I will rent while in the country of destination?",
  "home_faq_item15_content": "Your QIC travel insurance does not provide financial protection against damages that can happen to any vehicles you rent in your country of destination, including cars, motorbikes or any other vehicles you might rent or buy during your stay abroad. So if you are planning a motorcycle holiday make sure to get motor insurance",
  "home_faq_item16_header": "Does my travel insurance include a natural disaster cover (hurricane, volcano, etc.)?",
  "home_faq_item16_content": "Travel insurance does not cover losses or damages resulting from natural disasters, such as earthquakes, volcanic activities, floods or storms, in addition to other massive disasters, such as wars,  civil commotions, strikes and other events relating to Act of God.",
  "home_faq_item17_header": "What does my COVID-19 travel insurance cover include?",
  "home_faq_item17_content": "In the event of a confirmed infection with COVID-19 that occurs during your trip, your COVID-19 policy will cover the cost of compulsory approved government hospitalization, compulsory quarantine at a government approved hotel and medical treatments.",
  "home_faq_item18_header": "Does my COVID-19 travel insurance cover home quarantine and self-isolation related to the pandemic?",
  "home_faq_item18_content": "No. QIC’s COVID-19 travel insurance doesn’t cover home quarantine and self-isolation expenses.",
  "home_faq_item19_header": "Do you offer COVID-19 travel insurance cover to unvaccinated people?",
  "home_faq_item19_content": "Yes. QIC offers COVID-19 travel insurance to vaccinated, unvaccinated, recovered and people who have never been infected with COVID-19.",
  "home_faq_item20_header": "How can I file a claim?",
  "home_faq_item20_content": "You can file your claim on our website or by messaging us via WhatsApp at 5000 0742, or calling +971 4382 3700 / +971 43178500 and share your claim form, policy number, and other applicable documents such as receipts, valuations, medical, police or other reports as applicable.",
  "home_faq_item21_header": "When can I file my claim?",
  "home_faq_item21_content": "When you are already traveling and have run into problems, keep in mind the following important things. Claim filing is available 24/7. Loss or damage to baggage in transit, passport loss and trip cancellation must be reported immediately. Medical expenses claims must be filed within 48 hours of admission for in-patient treatments outside of Qatar.",
  "home_faq_item22_header": "What is policy excess?",
  "home_faq_item22_content": "The policy excess (also known as deductible) is the fixed amount of money that you have to pay for each and every claim you may have. The policy excess is there to offer you a cheaper and affordable overall premium for your travel insurance. The first portion of each and every loss is USD 50.",
  "home_faq_item23_header": "Where can I find QIC offices?",
  "home_faq_item23_content": "Our head office is located in West Bay, Doha, plus we have branches in Villaggio Mall, Landmark Mall, City Center Mall, Barwa Commercial Avenue, Ezdan Mall in Al Wakrah, Lulu Hypermarket in Al Gharafa, Lulu Al Messila, Al Khor, and Al Mansoura. If you plan to visit, you can choose our office near you.",
  "home_faq_item24_header": "What are your contact details for general travel insurance inquiries?",
  "home_faq_item24_content": "You can call our QIC Hotline at 8000 742, or WhatsApp us on 5000 0742 for all inquiries related to travel insurance.",
  "home_faq_item25_header": "What does travel insurance cover?",
  "home_faq_item25_content": "Travel insurance can compensate you if you have to suddenly cancel your trip, if you’ve lost your luggage or experienced unexpected health problems during your tour overseas, be it a family holiday or a business travel. Whether you are a backpacker during your gap year or a seasoned digital nomad; whether you travel alone, as a couple, or with friends, it’s always a wise decision to protect yourself against possible accidents. With travel insurance you won’t need to worry about flight delays, cancellations and interruptions and, when the worst comes to worst, it also covers emergency medical evacuation and emergency repatriation. However, stay safe and have a happy journey",
  "home_form_travelling_abroad": "Travelling Abroad",
  "home_form_visiting_qatar": "Visiting Qatar",
  "home_form_outbound_destinations_label": "Destination country",
  "home_form_inbound_destination_label": "Country of residence",
  "home_feedback_holder_text1": "«Professional services, friendly staff and very reasonable prices!»",
  "home_feedback_holder_author1": "Sameer Khan",
  "home_feedback_holder_author_desc1": "Travelled all over Europe",
  "home_feedback_holder_text2": "«Great team and service! Thank you QIC!»",
  "home_feedback_holder_author2": "Rashid Al Mahmoud",
  "home_feedback_holder_author_desc2": "First time abroad with QIC",
  "home_feedback_holder_text3": "«The best online travel insurance solutions in Qatar. Insurance is made easy for real»",
  "home_feedback_holder_author3": "Justin Houtan",
  "home_feedback_holder_author_desc3": "Traveled around Qatar for six months",
  "home_feedback_holder_text4": "«Got travel insurance at an affordable price with a COVID-19 cover in a few minutes. Highly recommended»",
  "home_feedback_holder_author4": "Dilum Jayanath",
  "home_feedback_holder_author_desc4": "Visited 4 countries",
  "quote_info_audlts": "Adults",
  "quote_info_children": "Children",
  "quote_info_outbound_title": "Outbound Travel Insurance",
  "quote_info_inbound_title": "Inbound Travel Insurance",
  "quote_info_inbound_to_qatar": "Inbound Travel Insurance",
  "quote_country_residence": "Country of residence",
  "qar": "QAR",
  "qic_covered": "Covered",
  "landing_award": {
    "title": "Why QIC",
    "award_title": "Best Travel Insurance Company in The Middle East 2024",
    "award_description": "The Global Banking & Finance Review Awards",
    "rating": "QIC enjoys good ratings by top rating agencies in the industry"
  },
  "travel_logo": {
    "item1": "Travel",
    "item2": "Insurance"
  },
  "outbound": {
    "personal_information": {
      "header": "Personal information"
    },
    "travelers": {
      "first_name": "First name",
      "last_name": "Family name",
      "qatar_id": "QID number",
      "email": "Email",
      "gender": {
        "male": "Male",
        "female": "Female",
        "label": "Gender"
      }
    },
    "contacts": {
      "title": "Contacts"
    },
    "traveling_persons": {
      "adults": {
        "label": "Adults",
        "annotation": "18–70 years"
      },
      "children": {
        "label": "Children",
        "annotation": "0–17 years"
      },
      "annotation": {
        "text": "Online insurance is available for travelers under <strong>70 years</strong>. To insure someone older,",
        "text_new": "Online insurance is available for travelers under 70 years. To insure someone older,",
        "link": "contact us"
      }
    },
    "destinations": {
      "change": {
        "label": "Country of destination",
        "placeholder": "Country of destination",
        "done_button": "Done"
      }
    },
    "plans": {
      "policy_information": {
        "header": "Policy information",
        "travellers": "Travelers",
        "period": "Insurance period",
        "people": "{personCount} person|{personCount} people",
        "destination": "Destination"
      },
      "plan_information": {
        "addon_badge": "Add-on",
        "policy_wording": "Policy wording",
        "addon_price_annotation": "Price doesn’t include add-ons",
        "addon_quote_text": "You can add this extension to travelers who require it on the final quote page",
        "addon_price_text": "QAR {price} per person"
      }
    },
    "calendar": {
      "trip_length": "Each trip can be up to 90 days",
      "trip_length_60": "Each trip can be up to 60 days",
      "first_departure": "First departure date"
    },
    "travelling_persons": {
      "annotation": "Online insurance is available for travelers under <strong>70 years</strong>. If you need to insure someone older, please contact us to continue"
    },
    "plan": {
      "wordldwide_ex": {
        "name": "Worldwide Excluding USA & Canada"
      },
      "fly_europe": {
        "name": "Fly Europe"
      },
      "worldwide": {
        "name": "Worldwide"
      },
      "regional": {
        "name": "Regional"
      },
      "worldwide_limited": {
        "name": "Worldwide limited"
      },
      "europe": {
        "name": "Europe"
      }
    },
    "cyber_security_addon": {
      "name": "Cyber security",
      "desc": "Protects against online purchase scam, identity theft, stolen funds, phishing, and other cyber threats. Coverage up to USD 5,000.",
      "desc_1": "Protects policyholder",
      "desc_2": "for up to USD 5,000",
      "desc_3": "against online purchase scam, identity theft, stolen funds, phishing, and other cyber threats."
    },
    "select_plan": {
      "header": "Customize your plan",
      "policy_info": {
        "number_of_travellers": "Number of travelers"
      },
      "included_header": "What’s included",
      "coverage": {
        "label": "Coverage",
        "worldwide": "Worldwide",
        "worldwide_excl": "excluding USA & Canada",
        "worldwide_desc": "Policy doesn’t cover travel to Iran, North Korea, and Venezuela",
        "regional": "GCC, Arab Countries, ISC, & SEA",
        "regional_desc": "Policy covers the GCC, Arab countries, India, Sri Lanka, Bangladesh, South Korea, Philippines, Indonesia, Nepal, and Bhutan",
        "fly_europe": "Schengen area",
        "fly_europe_desc": "All 29 Schengen countries"
      },
      "coverage_limit": {
        "label": "Coverage limit",
        "europe_limit": "USD 50,000",
        "non_europe_limit": "USD 1,000,000",
        "worldwide_desc": "Max coverage for medical treatment abroad",
        "regional_europe_desc": "Max coverage for medical treatment in the covered countries"
      },
      "addon_annotation": "The final price may change due to the number of insured people. Price doesn’t include add-ons",
      "select_button": "Get for QAR {number}",
      "extra_benefits": {
        "title": "Extra benefits",
        "extended_coverage": "Extended coverage",
        "increased_limit": "Increased limit",
        "increased_limit_desc": "Max coverage for medical treatment abroad"
      },
      "extended_coverage": {
        "desc": "Policy doesn’t cover travel to Iran, North Korea, and Venezuela"
      },
      "one_year_policy": {
        "title": "I want a one-year policy",
        "trips": "Unlimited international trips",
        "trip_days": "30/60/90 days or more",
        "long_term": "Long term stay"
      },
      "insurance_values": {
        "header_two_plans": "Choose your plan",
        "header_one_plan": "Your plan",
        "travelers": "{travelersCount} traveler| {travelersCount} travelers",
        "discount": "{discount}% off",
        "category_1": {
          "label": "Health",
          "item_1": {
            "name": "Emergency medical care",
            "desc": "USD 1,000,000",
            "desc_flyeurope": "USD 50,000",
            "pop_desc_1_1": "Emergency hospital care. ",
            "pop_desc_1_2": "Inpatient treatment, hospital stays, surgery, meds",
            "pop_desc_2_1": "Medical evacuation. ",
            "pop_desc_2_2": "Transport to the nearest hospital or back home if critically ill",
            "pop_desc_3_1": "Premature birth care. ",
            "pop_desc_3_2": "Newborn medical costs in case of premature birth before 32 weeks",
            "pop_desc_4_1": "Child hospitalization. ",
            "pop_desc_4_2": "Parent or guardian stay when child younger than 12 y.o. admitted",
            "pop_desc_5_1": "24/7 medical assistance. ",
            "pop_desc_5_2": "Any assistance services when the insured person suffering a medical emergency during the trip",
            "pop_desc": "Emergency dental care to relieve pain, basic fillings, repairs"
          },
          "item_2": {
            "name": "Emergency dental treatment",
            "desc": "USD 250 per claim"
          },
          "item_3": {
            "name": "Winter sports",
            "pop_desc": "Ski or snowboarding accidents"
          },
          "item_4": {
            "name": "COVID-19",
            "pop_desc": "Treatment, quarantine, and trip interruption",
            "pop_desc_reg": "Treatment, quarantine, and trip interruption.\u2028Available only in the Worldwide plan"
          },
          "item_2_1": {
            "name": "Search and rescue",
            "desc": "USD 10,000",
            "pop_desc": "If lost or injured in remote areas like mountains, sea, etc."
          },
          "item_2_2": {
            "name": "Travel accident",
            "desc": "USD 50,000",
            "pop_desc": "Death, loss of limbs or permanent disablement from a travel accident"
          },
          "quote_desc": "Emergency hospital care, medical evacuation, newborn care, child hospitalization, repatriation, and 24/7 medical assistance"
        },
        "category_2": {
          "label": "Belongings",
          "item_1": {
            "name": "Baggage loss or damage",
            "desc": "USD 5,000",
            "pop_desc": "Theft or damage to baggage during travel, due to crime, fire, or accidents"
          },
          "item_2": {
            "name": "Passport loss",
            "desc": "USD 500",
            "pop_desc": "Replacement costs and related travel and hotel expenses if passport is lost or stolen"
          },
          "item_3": {
            "name": "Sports gear",
            "desc": "USD 1,000",
            "pop_desc": "Lost or damaged sports gear (e.g. tennis racket, skis, surfboard)"
          },
          "item_1_1": {
            "name": "Delayed baggage",
            "desc": "USD 500",
            "pop_desc": "Funds for essential items needed while waiting for delayed baggage"
          },
          "item_3_1": {
            "name": "Rental sports equipment",
            "desc": "USD 500",
            "pop_desc": "Rental cost if your gear is lost or damaged"
          },
          "quote_desc": "Lost, damaged or delayed baggage, passport loss, lost or damaged sports gear"
        },
        "category_3": {
          "label": "Trip",
          "item_1": {
            "name": "Trip cancellation or delay"
          },
          "item_2": {
            "name": "Personal liability",
            "desc": "USD 1,000,000",
            "pop_desc": "Legal fees if you’re sued for accidental injury or property damage abroad"
          },
          "item_3": {
            "name": "Legal help abroad",
            "desc": "USD 25,000",
            "pop_desc": "Legal costs to sue for injury or illness caused by others abroad"
          },
          "item_4": {
            "name": "Unscheduled return",
            "desc": "USD 2,500",
            "pop_desc": "Covers emergency returns triggered by serious illness, injury, or other insured events"
          },
          "item_1_1": {
            "name": "Trip cancellation",
            "desc": "USD 5,000",
            "pop_desc": "Non-refundable trip costs if cancelled due to illness, death, job loss, pregnancy, etc."
          },
          "item_1_2": {
            "name": "Travel delay",
            "desc": "USD 5,000",
            "pop_desc": "Meals and accommodation if your trip is delayed by more than 2 hours due to uncontrollable circumstances"
          },
          "item_4_1": {
            "name": "Hijack"
          },
          "item_4_2": {
            "desc": "USD 1,500"
          },
          "item_4_3": {
            "pop_desc": "Daily compensation of USD 250 during transport hijack situations"
          },
          "quote_desc": "Trip cancellation and delay, legal help abroad, hijack compensation, personal liability"
        },
        "addon": "Add-on",
        "plan": {
          "worldwide": {
            "name": "Total protection\u2028+ USA & Canada"
          },
          "worldwideexcl": {
            "name": "Total protection"
          },
          "regional": {
            "name": "Regional"
          },
          "flyeurope": {
            "name": "Basic"
          },
          "ooredoo": {
            "name": "Travel insurance"
          }
        },
        "pop_up": {
          "header_upd": "What’s covered"
        },
        "common_values": "Health, belongings, and trip protection",
        "addons": {
          "winter_covid": "Available add-ons: Winter sports and COVID-19",
          "validity": {
            "all_countries": "Valid in all countries",
            "common_excl": "Doesn’t cover Iran,\u2028North Korea, and Venezuela",
            "excl_usa": "Not valid in the USA and Canada",
            "also_common_excl": "Also doesn’t cover Iran,\u2028North Korea, and Venezuela",
            "regional": "Valid only in the Middle East and Asia",
            "regional_gcc": "GCC: Bahrain, Kuwait, Oman, Qatar, Saudi Arabia, United Arab Emirates.",
            "regional_arab": "Arab Countries: Iraq, Jordan, Lebanon, Palestine, Syria, Yemen.",
            "regional_isc": "ISC: India, Pakistan, Sri Lanka, Bangladesh.",
            "regional_sea": "SEA: Korea, Philippines, Indonesia, Nepal, Bhutan.",
            "valid_excl_usa": "Valid in all countries except the USA and Canada",
            "europe": "Valid only in Schengen countries",
            "europe_countries": "Austria, Belgium, Bulgaria, Croatia, Czech Republic, Denmark, Estonia, Finland, France, Germany, Greece, Hungary, Iceland, Italy, Latvia, Liechtenstein, Lithuania, Luxembourg, Malta, Netherlands, Norway, Poland, Portugal, Romania, Slovakia, Slovenia, Spain, Sweden, Switzerland"
          },
          "covid": "COVID-19 add-on is available",
          "not_covid": "COVID-19 add-on isn’t available"
        },
        "covered": {
          "header": "What's covered",
          "annottation": {
            "ww_wwexcl": "Protection included in both Worldwide and Worldwide limited plans.",
            "wwexcl_regional": "Protection included in both Worldwide and Regional plans."
          },
          "health": {
            "header": "Health",
            "em_medical_care": {
              "label": "Emergency medical care",
              "amount": "USD 1,000,000",
              "tooltip": "Emergency hospital care, medical evacuation, newborn care, child hospitalization, repatriation, and 24/7 medical assistance",
              "desc": "Emergency medical expenses, including dental treatment"
            },
            "em_dental": {
              "label": "Emergency dental treatment",
              "amount": "USD 250 per claim"
            },
            "rescue": {
              "label": "Search and rescue",
              "amount": "USD 10,000"
            },
            "travel_accident": {
              "label": "Travel accident",
              "amount": "USD 50,000"
            }
          },
          "trip": {
            "header": "Trip",
            "cancellation": {
              "label": "Trip cancellation or delay",
              "amount": "USD 5,000"
            },
            "pers_liability": {
              "label": "Personal liability",
              "amount": "USD 1,000,000"
            },
            "legal_help": {
              "label": "Legal help abroad",
              "amount": "USD 25,000"
            },
            "unsch_return": {
              "label": "Unscheduled return",
              "amount": "USD 2,500"
            },
            "desc": "Trip cancellation or delay, legal expenses, and other travel accidents"
          },
          "belongings": {
            "header": "Belongings",
            "bag_loss": {
              "label": "Baggage loss or damage",
              "amount": "USD 5,000"
            },
            "passport": {
              "label": "Passport loss",
              "amount": "USD 500"
            },
            "sports_gear": {
              "label": "Sports gear",
              "amount": "USD 1,000"
            },
            "desc": "Loss or damage to baggage, passport, and sports gear"
          },
          "addons": {
            "header": "Add-ons",
            "winter_sports": {
              "label": "Winter sports",
              "amount": "USD 1,000,000"
            },
            "covid": {
              "label": "COVID-19",
              "amount": "USD 5,000",
              "worldwide_note": "Available only in the Worldwide plan"
            },
            "annotation": "Upgrade your coverage on the quote page"
          }
        },
        "medical_care_ww": "Up to USD 1,000,000 for emergency medical care",
        "belongings_incl": "Belongings loss or damage is covered",
        "cancellation_incl": "Trip cancellation or delay is covered",
        "medical_care_europe": "Up to USD 50,000 for emergency medical care",
        "belongings_excl": "Belongings loss or damage isn't covered",
        "cancellation_excl": "Trip cancellation or delay isn’t covered",
        "payout_limit": "Payout limit",
        "visa_valid": "Valid for visa",
        "coverage": "Coverage",
        "ww_coverage": {
          "header": "Worldwide coverage",
          "common_excl": "Valid in all countries except Iran, North Korea, and Venezuela",
          "usa_excl": "Valid in all countries except the USA, Canada, Iran, North Korea, and Venezuela"
        },
        "destinations_list": {
          "name": "Any country except Iran, North Korea, and Venezuela"
        }
      }
    },
    "addon": {
      "learn_more": "Learn more",
      "error": "Couldn’t include the add-on in your quote. Please try again"
    },
    "personal_info": {
      "qid_exp_date": "QID expiry date"
    }
  },
  "outbound_travelers_add_mobile_number": "Mobile number",
  "inbound": {
    "personal_information": {
      "header": "Personal details"
    },
    "contacts": {
      "title": "Contacts"
    },
    "traveling_persons": {
      "adults": {
        "label": "Adults",
        "annotation": "18–65 years"
      },
      "children": {
        "label": "Children",
        "annotation": "0–17 years"
      },
      "description": {
        "text": "Online insurance is available for travelers under <strong>65 years</strong>. To insure someone older,",
        "text_new": "Online insurance is available for travelers under 65 years. To insure someone older,",
        "link": "contact us"
      },
      "count_warning": "Only <b>30 travelers</b> can be insured under one policy",
      "count_warning_new": "Only 30 travelers can be insured under one policy",
      "annotation": "Online insurance is available for travelers under <strong>65 years</strong>. If you need to insure someone older, please contact us to continue"
    },
    "view_plan": {
      "policy_wording": "Policy wording"
    },
    "plan": {
      "policy_information": {
        "people": "person|people",
        "header": "Policy information",
        "header_new": "Policy details",
        "period": "Insurance period",
        "travellers": "Travelers"
      },
      "inbound": {
        "name": "Inbound Travel Insurance"
      }
    },
    "travelers": {
      "add_button": "Add traveler"
    },
    "country_of_residence": {
      "mandatory:insurance_wordings": {
        "start": "To enter Qatar you must have a mandatory health insurance.",
        "start_new": "To enter Qatar, you must have the mandatory health insurance.",
        "link": "Get it",
        "link_new": "Buy health and inbound policies together",
        "end": "separately"
      }
    }
  },
  "qic": {
    "error": {
      "fill_field": "Fill in the field",
      "email": {
        "format": "Enter an email in the format example{'@'}domain.com"
      },
      "phone": {
        "format": "Invalid format",
        "empty": "Fill in the field",
        "consist_11_digits": "Invalid format"
      },
      "qid": {
        "start_with_2_3": "It has to start with 2 or 3",
        "consist_11_digits": "It has to consist of 11 digits"
      },
      "max_age_inbound": "Coverage is available only for adults under 65",
      "max_age_outbound": "Coverage is available only for adults under 70",
      "min_age": "Coverage is available only for adults aged 18 and above"
    },
    "common": {
      "insuranceLimit": "Insurance limit:",
      "learn_more": "Learn more"
    },
    "close": "Close"
  },
  "plan": {
    "single_trip": {
      "change_dates": {
        "header": "Change travel dates",
        "save_button": {
          "text": "Save"
        }
      }
    },
    "multi_trip": {
      "change_dates": {
        "header": "Change departure date",
        "annotation": "6 months multi-trip from {departureDate} till {endDate}.\u2028\nThe maximum trip length is 90 days"
      }
    }
  },
  "inbound_traveling_persons": {
    "change": {
      "header": "Number of travelers",
      "save_button": "Save"
    }
  },
  "check_quote": {
    "policy_holder": {
      "contacts": {
        "title": "Contacts"
      },
      "label": "Policyholder"
    },
    "insured_person": {
      "winter_cover_badge": "Winter Cover"
    },
    "header": "Your quote",
    "travel_dates": "Insurance period",
    "full_name": "Full name",
    "covid_cover": {
      "risks": {
        "annotation": "We won't cover any expenses related to COVID-19\u2028if you remove this add-on"
      },
      "limit": "USD 5,000"
    },
    "winter_cover": {
      "risks": {
        "annotation": "We won't cover medical assistance for skiing or snowboarding injuries if you remove this add-on"
      },
      "limit": "Included in USD 1,000,000 emergency medical care coverage"
    },
    "person": "per person",
    "people": "for {count} person | for {count} people",
    "coins_reward": "Coins reward",
    "ooredoo": {
      "header": "Mobile plans for travelers",
      "desc": "After purchase, you’ll get a link to the Ooredoo’s website. It offers data, calls, and SMS for 170+ destinations"
    }
  },
  "travel": {
    "success_screen": {
      "header": "You are insured",
      "policy_number": "Policy number:",
      "email_sent": "We've sent the policy information to your email",
      "policy_download": "Download policy",
      "qdapp_banner": {
        "header": "Manage your policy in QIC app",
        "annotation": "Access, download, and share it wherever you want",
        "download_button": "Download"
      },
      "qic_domains": {
        "header": "General addresses we use to contact you:",
        "annotation": "qic.online, qic.com.qa, or qicgroup.com.qa"
      },
      "cyber_policy_download": "Cyber security policy",
      "ooredoo": {
        "header": "Get mobile plan for travelers",
        "desc": "Ooredoo offers weekly and monthly packages with data, calls, and SMS for 170+ destinations",
        "button": "See plans"
      },
      "travel_kit": {
        "title": "Your travel kit"
      },
      "home_insurance": {
        "title": "25% off home insurance",
        "badge": "Valid for 48 hours",
        "description": "Protect your home while you're away",
        "feature_1": "Covers damage to walls, roof, and structure",
        "feature_2": "Protects furniture and other valuables",
        "feature_3": "Items you carry also stay safe abroad",
        "button": "Use your discount"
      },
      "go_to_policies": {
        "button": "Go to my policies"
      }
    },
    "outbound": {
      "select_plan": {
        "from_title": "From",
        "select_button": "Select",
        "back_to_plans": "Back to plans",
        "whats_covered_button": "What's covered",
        "continue_button": "Continue"
      },
      "quote": {
        "insurance_period": {
          "name": "Insurance period"
        },
        "destination": {
          "name": "Destination"
        }
      },
      "covid": {
        "price_desc": {
          "text": "Price for {count} people"
        }
      },
      "cyber_security_addon": {
        "price_desc": {
          "text": "for {firstName} {secondName} only"
        }
      },
      "winter_sport": {
        "price_desc": {
          "text": "for"
        }
      },
      "popular_destinations": {
        "gcc": "GCC",
        "worldwide": "Worldwide",
        "schengen": "Schengen",
        "georgia": "Georgia"
      }
    },
    "inbound": {
      "quote": {
        "country": {
          "name": "Country of residence"
        },
        "plan": {
          "name": "Inbound insurance"
        }
      }
    },
    "common": {
      "failed": {
        "heading": "Failed to load",
        "text": "Try again or contact us to get help"
      },
      "quote": {
        "insured_traveler": {
          "name": "Insured traveler"
        },
        "inclusive_cover": {
          "name": "Inclusive cover"
        }
      },
      "edit": {
        "button": "Edit"
      },
      "quote_price_desc": {
        "name": "Price for {count} people"
      },
      "continue": {
        "button": "Continue"
      },
      "fiil_personal_info": {
        "fill": {
          "header": "Fill in the information"
        }
      },
      "choose_option": {
        "error": "Choose an option"
      },
      "get_in_touch": {
        "request_callback": "Request a callback",
        "or": "OR"
      },
      "back": {
        "button": "Back"
      },
      "progress_bar": {
        "step_1": "Travel details",
        "step_2": "Contacts",
        "step_3": "Coverage",
        "step_4": "Personal details",
        "step_5": "Quote"
      },
      "server_error_popup": {
        "heading": "Couldn’t send request",
        "subheading": "Please try again or come back later"
      },
      "callback_sent_popup": {
        "heading": "Callback request sent",
        "subheading": "Our operators will contact you within a business day"
      },
      "quote_loader": {
        "text_1": "Packing all your travel essentials…",
        "text_2": "Adding a few extra things for comfort…",
        "text_3": "A little longer than expected, but the suitcase is almost ready…"
      },
      "success": {
        "text_1": "Getting your policy ready…",
        "text_2": "Sending the policy to your email..."
      }
    },
    "quote": {
      "inclusive_cover": {
        "ooredoo": {
          "point1": {
            "text": "Emergency medical care up to USD 35,000"
          },
          "point2": {
            "text": "COVID-19 coverage up to USD 2,500"
          },
          "point3": {
            "text": "24/7 medical assistance"
          }
        }
      }
    },
    "success_page": {
      "hotel_block": {
        "badge": "New in QIC App",
        "desc": "Find the right hotel, book in minutes, and manage your stay in QIC App",
        "button": "Choose hotel",
        "header": "Your stay abroad starts here"
      }
    }
  },
  "qic_data_protected_reminder": "All data we collect is protected and help us improve your user experience",
  "qic_user_contacts_acceptance": "I agree to receive information and updates about new products, services, promotions, benefits, and rewards",
  "contacts": {
    "privacy_policy": {
      "annotation": "By continuing, you agree to our",
      "link": "Privacy Policy"
    }
  },
  "outbound_travel_type_single_desc_60": "Up to 60 days",
  "contact_us_popup": {
    "heading": "We are here to help",
    "whatsapp": {
      "title": "Contact us via WhatsApp",
      "button": "Open WhatsApp Chat"
    },
    "phone": {
      "title": "Or let us call you"
    },
    "send": {
      "button": "Send"
    },
    "informing": {
      "text": "All data we collect is protected and help us improve your user experience"
    }
  },
  "qic_error_go_home": "Go to main page",
  "qic_need_help_popup_header": "We are here to help",
  "qic_base_error_contact_us": "Contact us in a way convenient for you",
  "qic_cant_provide_wa": "Open WhatsApp",
  "qic_error_hotline": "Hotline",
  "qic_base_error_heder_line": "Something went wrong",
  "qic_base_error_message": "Please try again or contact the support team if the problem persists",
  "qic_error_try_again": "Try again",
  "qic_base_error_phone_header": "We are here to help",
  "qic_need_help_sent_popup_header": "We have received your request",
  "qic_need_help_sent_popup_message": "Manager will contact you soon",
  "qic_quote_number": "Quote Number",
  "qic_quote_insurance_amount": "Insurance Limit",
  "checkout": {
    "payment_block": {
      "promo_code": {
        "title": "Active promo code"
      },
      "your_quote": {
        "title": "Your quote"
      },
      "addons": {
        "title": "Additional covers",
        "title_new": "Add-ons"
      },
      "discounts": {
        "title": "Discounts"
      },
      "total": {
        "title": "Total"
      },
      "select_method": {
        "title": "Select payment method"
      },
      "credit_card": {
        "title": "Credit or debit card"
      },
      "naps_debit": {
        "title": "Qatari debit card"
      },
      "apple_pay": {
        "title": "Apple Pay"
      },
      "google_pay": {
        "title": "Google Pay"
      },
      "checkbox_confirmation": {
        "text": "I agree to the ",
        "link": "Terms & Conditions"
      },
      "confirmation": {
        "text": "By continuing, you agree to our",
        "link": "Payment Terms & Conditions"
      },
      "security_informing": {
        "text": "All payments on this page are protected by SSL"
      }
    }
  },
  "qic_quote_checkout_button": "Buy Now",
  "qic_base_error_heder_line1": "Something went",
  "qic_base_error_heder_line2": "wrong",
  "qic_dropdown_save_button": "Save",
  "qic_have_promocode": "Use promo code",
  "qic_promocode": "Promo Code",
  "qic_contact_us": "Need Help? Contact Us",
  "qic_promocode_invalid": "Invalid promo code. Check it for typos and try again",
  "qic_promocode_applied": "Promo code applied",
  "qic_promocode_apply": "Apply",
  "till": "till",
  "qic_ok": "OK",
  "travelers": {
    "add_button": "Add"
  },
  "payment_terms_popup": {
    "heading": "Payment Terms & Conditions",
    "dibsy": {
      "text": "Payment processing services for you as a customer of Qatar Insurance Company Q.S.P.C. (“QIC”) are provided by Paywise QFC Branch’s (“Dibsy”). The information being provided is only for the convenience of the customers and does not amount to an offer, advertisement, invitation or promotion of any product or services of Dibsy or any third parties. QIC does not retain or control or share any information related to your use of the payment processing services provided by Dibsy. QIC shall not be responsible and / or incur any liability and/or guarantee or undertake any liability or responsibility for the payment services provided by Dibsy. We request you to read the terms, conditions and disclaimers of Dibsy’s website before accessing services of Dibsy. QIC and its affiliates, subsidiaries, employees, officers, directors and agents, expressly disclaim any liability for any deficiency in the services offered by Dibsy. Neither QIC nor any of its affiliates nor their directors, officers and employees will be liable to or have any responsibility of any kind for any loss that you incur in the event of any deficiency in the services of Dibsy, failure or disruption of the services provided by Dibsy, or resulting from the act or omission of any other party involved in the payment process."
    },
    "qnb": {
      "text": "At your request, you are being re-directed to a third party site - Qatar National Bank Payment Site, wherein you can make your payment from a different bank account. Qatar Insurance Company (QIC) does not guarantee or warrant the accuracy or completeness of the information, materials, services or the reliability of any service, advice, opinion, statement or other information displayed or distributed on the third party site. You shall access this site solely for purposes of payment of your policy premium and you understand and acknowledge that availing of any services offered on the site or any reliance on any opinion, advice, statement, memorandum, or information available on the site shall be at your sole risk. Qatar Insurance Company and its affiliates, subsidiaries, employees, officers, directors and agents, expressly disclaim any liability for any deficiency in the services offered by Qatar National Bank whose site you are about to access. Neither Qatar Insurance Company., nor any of its affiliates nor their directors, officers and employees will be liable to or have any responsibility of any kind for any loss that you incur in the event of any deficiency in the services of Qatar National Bank to whom the site belongs, failure or disruption of the site of Qatar National Bank, or resulting from the act or omission of any other party involved in making this site or the data contained therein available to you, or from any other cause relating to your access to, inability to access, or use of the site or these materials."
    }
  },
  "close": {
    "button": "Close"
  },
  "day_1": "Sun",
  "day_2": "Mon",
  "day_3": "Tue",
  "day_4": "Wed",
  "day_5": "Thu",
  "day_6": "Fri",
  "day_7": "Sat",
  "usd": "USD",
  "price": "Price:",
  "ramadan": {
    "header": {
      "text": {
        "1": "Win a car",
        "2": "with QIC!"
      }
    },
    "popup": {
      "header": "Win Jetour T2 and other prizes",
      "subtitle": {
        "1": "Buy travel insurance",
        "2": "and get",
        "3": "tickets to enter the raffle"
      }
    },
    "checkout": {
      "total": "Tickets to your raffle balance"
    },
    "success_page": {
      "title": "You got tickets",
      "subtitle": "Collect your tickets in QIC App and get the chance to win Jetour T2 and other prizes",
      "scan": "Scan to download",
      "button": {
        "go_to_store": "Go to store"
      }
    }
  },
  "addon": {
    "cyber": {
      "excess": {
        "info": "Claims under USD 100 aren’t covered. For larger claims, USD 100 comes off the total",
        "amount": "USD 100",
        "label": "Excess:"
      }
    }
  },
  "cyber_security_addon": {
    "name": "Cyber security",
    "popup": {
      "header": {
        "1": "We’ve got you covered if",
        "2": "What’s not covered"
      },
      "desc": "Coverage up to USD 5,000.  Excess:USD 100. Claims under USD 100 aren’t covered. For larger claims, USD 100 comes off the total.",
      "block": {
        "1": {
          "header": "You’re scammed while shopping online",
          "desc": "You order a gadget online, pay upfront, but weeks later, your package never arrives, and the seller’s website disappears. With this coverage, you’re protected from fraudulent online purchases and can recover your money"
        },
        "2": {
          "header": "Your phone or laptop gets hit by ransomware or a cyberattack",
          "desc": "You come home, turn on your laptop, and realize all your files are locked by ransomware. A cyberattack has targeted your device. This coverage helps recover the costs of data recovery and secures your device"
        },
        "3": {
          "header": "Money was stolen from your account",
          "desc": "You receive an email that looks like it's from your bank, asking for your personal details. After following the instructions, you find out you've been scammed, and money was stolen. This coverage protects you from online scams and fraudulent transactions"
        },
        "4": {
          "header": "You lose files due to a system crash or cyber incident",
          "desc": "All your important files—work documents, photos, contacts—vanish after a system crash or a cyberattack. Instead of panicking, you can use your data restoration coverage to recover your lost files and get everything back on track without the extra costs"
        },
        "5": {
          "header": "Someone steals your personal info",
          "desc": "You apply for a loan and discover you already have an outstanding debt you didn’t take out. Someone stole your information to open accounts in your name. With identity theft protection, you’re covered for restoring your financial reputation"
        },
        "6": {
          "header": "You face cyberbullying",
          "desc": "You’re being harassed online, and it starts affecting your personal and professional life. Cyberbullying coverage helps with legal fees and provides support for counseling to deal with online harassment"
        }
      },
      "list": {
        "1": "Physical card theft",
        "2": "Any loss covered by your bank or other institution",
        "3": "Physical device damage",
        "4": "Internet connection loss"
      },
      "button": {
        "add": "Add to main coverage"
      }
    }
  },
  "bonuses": {
    "popup": {
      "description": {
        "user_not_registered": "You’ve earned Coins! Save up and spend them in QIC app",
        "user_registered": "You’ve earned Coins! Spend them in our app"
      }
    }
  },
  "common": {
    "domains_list": {
      "subtitle": "qic.online, qic.com.qa, or qicgroup.com.qa",
      "title": "General addresses we use to contact you:"
    },
    "go_to_app": {
      "button": "Go to app"
    },
    "whatsapp": {
      "button": "Chat on WhatsApp"
    },
    "call": {
      "button": "Call"
    },
    "get_in_touch": "Get in touch",
    "availabilty_hours": "We’re available daily, 7 am – 8 pm"
  },
  "success_page": {
    "bonuses": {
      "label": {
        "see_more": "See more"
      }
    }
  },
  "app_banner": {
    "manage_policy": {
      "desktop": {
        "subtitle": "Access, download, and share it wherever you want",
        "title": "Manage your policy in QIC app"
      },
      "mobile": {
        "subtitle": "Manage your policy",
        "title": "QIC app"
      }
    }
  },
  "qar_price": "QAR {price}",
  "select_plan": {
    "coins": "You’ll get +{value}",
    "coins_discount": "Coins discount",
    "earn_coins": "Earn {coins}",
    "price_with_coins": "or QAR {price} with Coins",
    "spend_coins": "Spend {coins}"
  }
}
